export enum Screen {
  HOME = 'HOME',
  FORM = 'FORM',
  CHAT = 'CHAT',
  DICTIONARY = 'DICTIONARY',
  DREAM_DETAIL = 'DREAM_DETAIL',
  LETTER = 'LETTER',
  CATEGORY = 'CATEGORY',
  PRIVACY = 'PRIVACY',
  APP = 'APP'
}

export enum Gender {
  MALE = 'ذكر',
  FEMALE = 'أنثى'
}

export enum MaritalStatus {
  SINGLE = 'أعزب/عزباء',
  MARRIED = 'متزوج/متزوجة',
  DIVORCED = 'مطلق/مطلقة',
  WIDOWED = 'أرمل/أرملة'
}

export interface UserData {
  gender: Gender;
  maritalStatus: MaritalStatus;
  age: number | string;
  dreamTime?: string;
  dreamContent?: string;
  dreamDescription?: string;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'model';
  text: string;
  isTyping?: boolean;
}

export interface DreamTopic {
  slug: string;
  arabicSlug: string;
  name: string;
  letter: string;
  category: string;
  categorySlug: string;
  title: string;
  metaDescription: string;
  keywords: string[];
  summary: string;
  quickAnswer?: string; // Direct Answer for snippet/instant answer
  editorialMeaning?: string; // معنى الرمز في المنام — صياغة تحريرية مستندة إلى المادة التراثية
  ibnSirinInterpretation: string;
  nabulsiInterpretation: string;
  scholarlyNuances?: string; // أصول التعبير وتأصيل ابن شاهين والظاهري
  comparisonTable?: {
    aspect: string;
    goodMeaning: string;
    warningMeaning: string;
    context: string;
  }[];
  cases: {
    single: string;    // للعزباء
    married: string;   // للمتزوجة
    pregnant: string;  // للحامل
    divorced: string;  // للمطلقة
    man: string;       // للرجل
  };
  keyVariations: {
    title: string;
    description: string;
  }[];
  practicalAdvice?: {
    title: string;
    advice: string;
  }[];
  commonMistakes?: string[];
  faqs: {
    question: string;
    answer: string;
  }[];
  relatedSlugs: string[];
  datePublished: string;
  dateModified: string;
  isDictionary?: boolean;
  sourceResolved?: 'editorial' | 'dictionary'; // مصدر حشو المحتوى: تحريري أو قاموسي خام
}

export interface DreamCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
}
